"use strict";
import { hoverFor } from "../../annotation/bounding_box";
import { Action } from "../actions";
export default function setHover(hoveredComponent = {}, action) {
  switch (action.type) {
    case Action.SET_HOVERED_COMPONENT: {
      const { views, mousePos, cropping } = action;
      const getHoverInfo = hoverFor(mousePos);
      const addHoverInfo = (view) => {
        const { typeID, dragPoints } = view;
        const { hovered, dragPointIndex } = getHoverInfo(typeID, dragPoints);
        return {
          viewID: view.guid,
          hovered,
          dragPointIndex
        };
      };
      const isHovered = (hoverInfo) => hoverInfo.hovered;
      const isCropping = (cropOn) => (view) => cropOn ? view.typeID === "Crop" : view.typeID !== "Crop";
      const pickBest = (currentBest, hoverInfo) => {
        if (currentBest.viewID && currentBest.viewID !== hoverInfo.viewID) {
          return currentBest;
        }
        return hoverInfo;
      };
      const candidates = Object.values(views).filter(isCropping(cropping)).map(addHoverInfo).filter(isHovered);
      const best = candidates.length > 1 ? candidates.reduce(pickBest, hoveredComponent) : candidates[0];
      return best || {};
    }
    default:
      return hoveredComponent;
  }
}
